import { httpFetch } from '../http/actions'
import {
  GET_DAY_DISPONIBLE,
  GET_DAY_DISPONIBILITES,
  GET_DAY_DISPONIBILITES_SUCCESS,
  GET_DAY_DISPONIBILITES_FAILURE,
  GET_DAY_DISPONIBLE_SUCCESS,
  GET_DAY_DISPONIBLE_FAILURE,
} from './constants'
import queryString from 'query-string'

const euromaticApi = process.env.REACT_APP_EDIPARSER_MS_URL
const apiDisponibilites = process.env.REACT_APP_AVAILABILITY_MS_URL

const scheduleOrderMiddleware = (store) => (next) => (action) => {
  if (action.type === GET_DAY_DISPONIBLE) {
    const { dateDebut, dateFin, codePostal } = action.payload
    store.dispatch(
      httpFetch({
        endPoint: `${euromaticApi}partners/available-rdv-euromatic/${dateDebut}/${dateFin}/${codePostal}`,
        success: GET_DAY_DISPONIBLE_SUCCESS,
        failure: GET_DAY_DISPONIBLE_FAILURE,
      })
    )
  }

  if (action.type === GET_DAY_DISPONIBILITES) {
    store.dispatch(
      httpFetch({
        endPoint: `${apiDisponibilites}api/v1/time-slots/all/available/appointments?${queryString.stringify(
          action.payload
        )}`,
        success: GET_DAY_DISPONIBILITES_SUCCESS,
        failure: GET_DAY_DISPONIBILITES_FAILURE,
      })
    )
  }

  next(action)
}

export default scheduleOrderMiddleware
